import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { FileDown, Play } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function BriefingPage() {
  const {
    t
  } = useLanguage();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a1628] pt-32 pb-20 px-6" data-id="element-502" data-mp="2rqkc5gfthldd">
      <div className="max-w-3xl mx-auto" data-id="element-503" data-mp="2ror2ds9wql15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-504" data-mp="2wqghbj093iui">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-505" data-mp="3ah225d99m2v1">
            {t.briefing.title}
          </h1>
          <p className="text-white/60 text-lg" data-id="element-506" data-mp="3fh7me8d7gn33">{t.briefing.subtitle}</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#0f1d35] border border-white/5 rounded-2xl p-8 md:p-12 shadow-xl" data-id="element-507" data-mp="3kezkxl8cv7g9">
          <div className="prose prose-invert max-w-none" data-id="element-508" data-mp="2j1zwk74n261w">
            <p className="text-lg text-white/80 leading-relaxed" data-id="element-509" data-mp="2ezwj5cyesrdz">
              {t.briefing.intro1}{' '}
              <span className="text-[#38bdf8] font-semibold" data-id="element-510" data-mp="3bnj34beaqhaj">
                lkhv.eu/briefing
              </span>{' '}
              {t.briefing.intro2}
            </p>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-511" data-mp="31xzib070wdd1">
            <h3 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4" data-id="element-512" data-mp="2xxpadhzo7cvj">
              {t.briefing.documents}
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-513" data-mp="3ugwnxnoap7cf">
              <a href="https://drive.google.com/file/d/17xTGeN7IhKg96-8HwL9ocDjgCbIhQl03/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-514" data-mp="3povgcf22o4sq">
                <div className="flex items-center justify-center w-10 h-10 bg-red-500/15 rounded-lg" data-id="element-515" data-mp="1j036rbs2zgi3">
                  <FileDown className="w-5 h-5 text-red-400" data-id="element-516" data-mp="150v3o7ssro8m" />
                </div>
                <div data-id="element-517" data-mp="19zoj45rn9pbf">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-518" data-mp="1a07suz7557ed">
                    Letištní řád
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-519" data-mp="v4s499pby3pd">
                    PDF dokument
                  </span>
                </div>
              </a>
              <a href="https://drive.google.com/file/d/1Ujjfy7oQOWmSqugUhhd6lVnashclR4rP/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-520" data-mp="2phq8pcocm64s">
                <div className="flex items-center justify-center w-10 h-10 bg-red-500/15 rounded-lg" data-id="element-521" data-mp="sirbvdq8k2zz">
                  <FileDown className="w-5 h-5 text-red-400" data-id="element-522" data-mp="npojh8x72zld" />
                </div>
                <div data-id="element-523" data-mp="11hmhoopdbb2r">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-524" data-mp="11guotln5nrg6">
                    Směrnice RADIO
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-525" data-mp="1bh3lt1oz1gwm">
                    PDF dokument
                  </span>
                </div>
              </a>
              <a href="https://drive.google.com/file/d/1ezruudcBnJQMUMOmAMO5XMhlsrF2UZcu/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-526" data-mp="3d872o8pgfrpm">
                <div className="flex items-center justify-center w-10 h-10 bg-red-500/15 rounded-lg" data-id="element-527" data-mp="3jogwquyteg6j">
                  <FileDown className="w-5 h-5 text-red-400" data-id="element-528" data-mp="3ona1nz01cyv3" />
                </div>
                <div data-id="element-529" data-mp="3ol7ctiamdbry">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-530" data-mp="2r0bd6bjhyx8a">
                    Bezpečnostní Program
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-531" data-mp="2vwjm3773pu70">
                    PDF dokument
                  </span>
                </div>
              </a>
              <a href="https://drive.google.com/file/d/1GfFB_2Izk4Bv31pk0X4_CANfHaPFxu4K/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-532" data-mp="35q8ty6f3kkng">
                <div className="flex items-center justify-center w-10 h-10 bg-red-500/15 rounded-lg" data-id="element-533" data-mp="qc6r0148bbnj">
                  <FileDown className="w-5 h-5 text-red-400" data-id="element-534" data-mp="lb0xi12qvkcy" />
                </div>
                <div data-id="element-535" data-mp="gcpmhn0pr3t5">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-536" data-mp="gd975bhr06av">
                    Letištní pohotovostní plán
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-537" data-mp="6mwc2pcb4uqh">
                    PDF dokument
                  </span>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-538" data-mp="3ttow40sma4k9">
            <h3 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4" data-id="element-539" data-mp="3otu6s1ohpn1b">
              {t.briefing.winter}
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-540" data-mp="3jurbh8ybav6j">
              <a href="https://drive.google.com/file/d/1vnA15nAjBr4g3xpCFCKpQ7WFZT_t3NDt/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-541" data-mp="3a6vksm8ejktz">
                <div className="flex items-center justify-center w-10 h-10 bg-[#38bdf8]/15 rounded-lg" data-id="element-542" data-mp="3sxd4k1b9b637">
                  <FileDown className="w-5 h-5 text-[#38bdf8]" data-id="element-543" data-mp="1rbqrkzwpydv" />
                </div>
                <div data-id="element-544" data-mp="3k51i0qj9k2si">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-545" data-mp="3k5kzk6504p60">
                    Zimní školení 2026
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-546" data-mp="fqlagunbnaml">
                    PDF dokument
                  </span>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-547" data-mp="257p4s90msfla">
            <h3 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4" data-id="element-548" data-mp="255vyiutxjxdt">
              {t.briefing.accidents}
            </h3>
            <div className="flex flex-wrap gap-3" data-id="element-549" data-mp="2ey1ndvovxyos">
              <a href="https://drive.google.com/file/d/1VJcFdxKVlOBJpB-pgrPCCSxCkBVuYgG8/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-[#0a1628] border border-white/10 rounded-xl px-5 py-4 hover:border-[#38bdf8]/40 hover:bg-[#0a1628]/80 transition-all group" data-id="element-550" data-mp="2ewqittnm8mwm">
                <div className="flex items-center justify-center w-10 h-10 bg-[#38bdf8]/15 rounded-lg" data-id="element-551" data-mp="1w8bw3ikbzv1m">
                  <FileDown className="w-5 h-5 text-[#38bdf8]" data-id="element-552" data-mp="1ra0kp3ee1cha" />
                </div>
                <div data-id="element-553" data-mp="37kmeqw5d2asc">
                  <span className="text-white font-medium group-hover:text-[#38bdf8] transition-colors" data-id="element-554" data-mp="37o0ia7prgq1d">
                    Rozbor leteckých nehod
                  </span>
                  <span className="block text-xs text-white/40 mt-0.5" data-id="element-555" data-mp="1020gnlr31xcd">
                    PDF dokument
                  </span>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10" data-id="element-556" data-mp="19x0saksixvjx">
            <h3 className="text-sm font-medium text-white/50 uppercase tracking-wider mb-4" data-id="element-557" data-mp="1eplg95or1efj">
              {t.briefing.seminar}
            </h3>
            <div className="relative w-full aspect-video rounded-xl overflow-hidden border border-white/10" data-id="element-558" data-mp="1jo50n1np2i5s">
              <iframe src="https://www.youtube.com/embed/sUAyz4Kuayg" title="Seminář všeobecného letectví 2026" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-559" data-mp="1nruqdug3v5se" />
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}